import { useEffect, useState } from "react";
import GeospatialMapLayerType from "../../models/geospatialMapLayerType";
import DropdownOption from "../common/DropdownOption";
import geospatialMapLayerTypeHelper from "../../models/geospatialMapLayerTypeHelper";
import MapLayer from "../../models/mapLayer";
import Dropdown from "../common/Dropdown";
import Validator from "../common/Validator";
import ValidatorManager from "../../components/common/validationManager";

const validator = {
  layerUrl: "layerUrl",
};

const GeospatialMapLayerEdit: React.FC<{
  mapLayer: MapLayer;
  onSetMapLayer: any;
  isNew: boolean;
  validatorManager: ValidatorManager;
}> = ({ mapLayer, onSetMapLayer, isNew, validatorManager }) => {
  const [layerTypeOptions, setLayerTypeOptions] = useState<
    DropdownOption<GeospatialMapLayerType>[]
  >([]);

  const [selectedLayerTypeOption, setSelectedLayerTypeOption] = useState<
    DropdownOption<GeospatialMapLayerType> | undefined
  >();

  useEffect(() => {
    const options: DropdownOption<GeospatialMapLayerType>[] = [
      {
        value: GeospatialMapLayerType.XyzTiles,
        label:
          geospatialMapLayerTypeHelper.getGeospatialMapLayerTypeDisplayName(
            GeospatialMapLayerType.XyzTiles,
          ),
      },
    ];

    setLayerTypeOptions(options);

    if (!mapLayer.geospatialMapLayer) {
      return;
    }

    const selectedLayerTypeOption = options.find(
      (o) => o.value === mapLayer.geospatialMapLayer?.layerType,
    );
    setSelectedLayerTypeOption(selectedLayerTypeOption);

    if (!isNew) {
      validatorManager.setIsValid(validator.layerUrl, true);
    }
  }, [mapLayer, onSetMapLayer, isNew, validatorManager]);

  const onLayerTypeOptionChanged = async (
    newValue: DropdownOption<GeospatialMapLayerType>,
  ) => {
    setSelectedLayerTypeOption(newValue);

    if (!newValue.value) {
      return;
    }

    if (!mapLayer.geospatialMapLayer) {
      return;
    }

    const newMapLayer = { ...mapLayer };

    if (!newMapLayer.geospatialMapLayer) {
      return;
    }

    newMapLayer.geospatialMapLayer.layerType = newValue.value;

    onSetMapLayer(newMapLayer);
  };

  const onLayerUrlChanged = (event: any) => {
    const newValue = event.target.value;
    const isValid = newValue.length !== 0;
    validatorManager.setIsValid(validator.layerUrl, isValid);

    const newMapLayer = { ...mapLayer };

    if (!newMapLayer.geospatialMapLayer) {
      return;
    }

    newMapLayer.geospatialMapLayer.layerUrl = newValue;

    onSetMapLayer(newMapLayer);
  };

  return (
    <div>
      <div className="mb-3">
        <label htmlFor="layerType" className="form-label">
          Layer Type
        </label>
        <div>
          <Dropdown
            minWidth="200px"
            height="35px"
            options={layerTypeOptions}
            value={selectedLayerTypeOption}
            onChange={(newValue: any) => onLayerTypeOptionChanged(newValue)}
          />
        </div>
      </div>
      <div className="mb-3">
        <label htmlFor="layerUrl" className="form-label">
          Layer URL{" "}
          {mapLayer.geospatialMapLayer?.layerType ===
          GeospatialMapLayerType.XyzTiles
            ? `(ex. ${geospatialMapLayerTypeHelper.getGeospatialXyzTilesLayerSampleUrl()})`
            : ""}
        </label>
        <div className="input-group" style={{ width: "auto" }}>
          <Validator
            name={validator.layerUrl}
            errorMessage="Please enter the layer URL."
            validationManager={validatorManager}
          >
            <input
              type="text"
              className="form-control"
              id="layerUrl"
              value={mapLayer.geospatialMapLayer?.layerUrl}
              onChange={onLayerUrlChanged}
            />
          </Validator>
        </div>
      </div>
    </div>
  );
};

export default GeospatialMapLayerEdit;
